import { render, staticRenderFns } from "./OMDatepicker.vue?vue&type=template&id=6fadecd2&scoped=true"
import script from "./OMDatepicker.vue?vue&type=script&lang=js"
export * from "./OMDatepicker.vue?vue&type=script&lang=js"
import style0 from "./OMDatepicker.vue?vue&type=style&index=0&id=6fadecd2&prod&lang=scss&scoped=true"
import style1 from "./OMDatepicker.vue?vue&type=style&index=1&id=6fadecd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../omniscient/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fadecd2",
  null
  
)

export default component.exports